import cn from 'classnames';
import React from 'react';

import type { IItemsProps } from '..';
import { BreadcrumbsBaseItem } from '../BreadcrumbsBaseItem/BreadcrumbsBaseItem';

import styles from './BreadcrumbsBase.module.scss';

export const BreadcrumbsBase: React.FC<IItemsProps> = ({
  className,
  items,
  homeTitle = 'Сравни.ру',
  isHomeVisible = true,
}) => (
  <nav className={cn(styles.nav, className)}>
    {isHomeVisible && (
      <BreadcrumbsBaseItem href="/" title={homeTitle} id="breadcrumbs-item-0">
        {homeTitle}
      </BreadcrumbsBaseItem>
    )}
    {items.map((item) => (
      <BreadcrumbsBaseItem id={item.url} key={item.url} href={item.url} title={item.title}>
        {item.title}
      </BreadcrumbsBaseItem>
    ))}
  </nav>
);
